import { loadable } from '@shared/core/loadableFromNamedExport';

/**
 * Lazy entrypoint for the map widget.
 *
 * Host pages mount this, never `WeddingMap` directly: the map pulls in Google
 * Maps and the whole behaviour layer, and a page that only *might* show it
 * must not pay for the chunk when the flag is off.
 */
export const LazyWeddingMap = loadable(() => import(/* webpackChunkName: "content/wedding-map" */ './WeddingMap'), 'WeddingMap');
